import { useState } from "react";
import type { DealerDevice } from "@/gql/graphql";
import { Avatar, Logo } from "@trimble/modus-cmx";

type DeviceIconProps = Pick<DealerDevice, "iconUrl">;

const DeviceIcon = (props: DeviceIconProps) => {
  const { iconUrl } = props;
  const [failedIconUrl, setFailedIconUrl] = useState<string | null>(null);

  const showFallback = !iconUrl || failedIconUrl === iconUrl;

  return showFallback ? (
    <Logo emblem name="trimble" />
  ) : (
    <Avatar
      size="sm"
      imgSrc={iconUrl}
      onImageLoadError={() => {
        setFailedIconUrl(iconUrl);
      }}
    />
  );
};

export default DeviceIcon;
